"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHORT_CODE_LENGTH = void 0;
exports.normalizeShortCode = normalizeShortCode;
exports.isValidShortCode = isValidShortCode;
exports.defaultShortCodeBase = defaultShortCodeBase;
exports.nextFreeShortCode = nextFreeShortCode;
/**
 * Shared by the API (which applies it when a manufacturer is created and back-fills existing rows by the same rule in SQL)
 * and by the Manufacturer form (which previews it as the user types the name) — ONE definition, so the two cannot drift.
 */
/**
 * MANUFACTURER SHORT CODE — the three characters printed in the "Mfr" column of the pharmacy tax invoice.
 *
 * Owner, 2026-10-29: "manufacturer codes should come from manufacturer master creation … by default it should
 * take the manufacturer name first 3 digit, later user can change it if they want, in master or at creation".
 *
 * It is NOT `manufacturerCode` (`MFG2026000002`, a yearly sequence nobody can read at a glance and that is
 * thirteen characters wide); it is a short, human-readable tag the pharmacist recognises ("CIP", "GSK", "MIC").
 *
 * THE RULE, kept identical here and in the migration that back-fills existing rows
 * (`20261029100000_manufacturer_short_code`):
 *   1. the first three letters/digits of the name, upper case, punctuation and spaces skipped
 *      ("Micro Labs Limited" -> MIC, "3M India" -> 3MI); fewer than three are padded with 0 ("GE" -> GE0);
 *   2. it must be UNIQUE in the tenant, so when that is taken the first two characters take a digit
 *      2..9 (a second "GEN…" becomes GE2), then the first character takes two digits (G10..G99), then a
 *      plain number 100..999. That is only ever a DEFAULT: the user can type any other free code.
 */
exports.SHORT_CODE_LENGTH = 3;
const SHORT_CODE_PATTERN = /^[A-Z0-9]{3}$/;
/** Upper-case and trim — the form every short code is stored in. */
function normalizeShortCode(raw) {
    return raw.trim().toUpperCase();
}
/** Exactly three letters or digits (call on a normalised value). */
function isValidShortCode(code) {
    return SHORT_CODE_PATTERN.test(code);
}
/** First three letters/digits of the name, upper case; padded with 0 when the name has fewer. */
function defaultShortCodeBase(name) {
    const usable = name.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    return usable.padEnd(exports.SHORT_CODE_LENGTH, '0').slice(0, exports.SHORT_CODE_LENGTH);
}
/**
 * The default code for `name`: its first three characters when free, else the next free variant (see the
 * rule above). `taken` holds every code already used in the tenant, upper case. Null only when every
 * variant is taken — the caller then asks the user to type one.
 */
function nextFreeShortCode(name, taken) {
    const base = defaultShortCodeBase(name);
    if (!taken.has(base))
        return base;
    for (let digit = 2; digit <= 9; digit += 1) {
        const candidate = `${base.slice(0, 2)}${digit}`;
        if (!taken.has(candidate))
            return candidate;
    }
    for (let n = 10; n <= 99; n += 1) {
        const candidate = `${base.slice(0, 1)}${n}`;
        if (!taken.has(candidate))
            return candidate;
    }
    for (let n = 100; n <= 999; n += 1) {
        const candidate = String(n);
        if (!taken.has(candidate))
            return candidate;
    }
    return null;
}
//# sourceMappingURL=manufacturer-short-code.js.map